import axiosInstance from "./baseUrl";

export const getGeneralSettings = async () => {
  const response = await axiosInstance.get("/v1/settings/general");
  return response;
};

export const updateGeneralSettings = async (data: any) => {
  const response = await axiosInstance.put(
    `/v1/settings/general/${data.id}`,
    data
  );
  return response.data;
};

export const getCourierFeeSettings = async (courierId: string) => {
  const response = await axiosInstance.get(
    `/v1/currier/view_courier_fee_config/${courierId}`
  );
  return response.data;
};

export const updateCourierFeeSettings = async (data: any) => {
  const response = await axiosInstance.post(
    "/v1/currier/configure_courier_fee",
    data
  );
  return response.data;
};

export const getKycSettings = async () => {
  const response = await axiosInstance.get("/v1/kyc/kyc-settings");
  return response?.data;
};

export const updateKycSettings = async (data: any) => {
  const response = await axiosInstance.post("/v1/kyc/set-kyc-settings", data);
  return response.data;
};

export const getTransactionFeeSettings = async () => {
  const response = await axiosInstance.get("/v1/settings/transaction-fee");
  return response.data;
};

export const updateTransactionFeeSettings = async (data: any) => {
  const response = await axiosInstance.put(
    "/v1/banks/fee-settings",
    data
  );
  return response.data;
};
